import { TPAComponentProps } from '../../types';

export interface ErrorProps {
  error?: boolean;
}

export interface ErrorMessageWrapperProps extends TPAComponentProps {
  render(props: ErrorProps): any;
  error: boolean;
  disabled: boolean;
  errorMessage: string;
}
